import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export class InsuranceData {
  type: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  aokId: string;
  nonAokId: string;

  constructor() {
  }

}

/*
  Generated class for the IntroWizardServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class IntroWizardServiceProvider {

  firstName: string = '';
  insurer: string = '';
  insurance: InsuranceData;

  email: string = '';
  password: string = '';

  partnerCode: string = null;

  terms: boolean = false;
  contraindications: boolean = true;
  bgm: boolean;
  yuble: boolean;
  freeOffer: boolean;
  privacy: boolean = false;

  constructor(public http: HttpClient) {
    console.log('Hello IntroWizardServiceProvider Provider');
  }

  clear() {
    this.firstName = this.insurer = this.email = this.password = '';
    this.terms = false;
    this.contraindications = false;
    this.insurance = null;
    this.partnerCode = null;
  }

  getData():object {
    return {
      firstName: this.firstName,
      email: this.email,
      plainPassword: this.password,
      terms: this.terms,
      partnerCode: this.partnerCode,
      contraindications: this.contraindications,
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/intro-wizard-service/intro-wizard-service.ts